import { listUseCases } from "../../use-cases/registry";
import { hrefForUseCase } from "../../use-cases/links";
import { TS_CASE_STUDY_HREF } from "../../use-cases/case-studies/teachingStrategies";

const USE_CASE_LINKS = [
  ...listUseCases().map((u) => ({
    label: u.menuLabel,
    href: hrefForUseCase(u.slug),
  })),
  { label: "Teaching Strategies case study", href: TS_CASE_STUDY_HREF },
];

const JUICE_SITE = "https://www.juiceanalytics.com";

const POLICY_LINKS = [
  { label: "Acceptable Use Policy", href: `${JUICE_SITE}/acceptable-use` },
  { label: "Privacy Policy", href: `${JUICE_SITE}/privacy` },
  { label: "Terms of Use", href: `${JUICE_SITE}/terms-of-use` },
];

export const LandingFooter = () => (
  <footer className="bg-fwd-ink px-8 md:px-16 lg:px-20 py-10">
    <div className="flex flex-wrap items-center justify-between gap-4">
      <div className="font-display text-white text-base">
        Forward <span className="text-fwd-red">&middot;</span> Juice Analytics
      </div>
      <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-white/55 text-xs">
        <a
          href="tel:+16158548707"
          className="hover:text-white transition-colors"
        >
          (615) 854-8707
        </a>
        <span className="text-white/25" aria-hidden="true">
          |
        </span>
        <a
          href="mailto:info@juiceanalytics.com"
          className="hover:text-white transition-colors"
        >
          info@juiceanalytics.com
        </a>
      </div>
    </div>
    {/* Stacked under its label on phones; one row beside it from `sm` up. */}
    <nav
      aria-label="Use cases"
      className="mt-8 flex flex-col gap-3 sm:mt-6 sm:flex-row sm:items-baseline sm:gap-5"
    >
      <span className="text-white/40 text-xs font-bold tracking-[0.2em] uppercase">
        Use cases
      </span>
      <ul className="flex flex-col gap-2.5 text-sm sm:flex-row sm:flex-wrap sm:gap-x-5 sm:gap-y-2">
        {USE_CASE_LINKS.map((link) => (
          <li key={link.href}>
            <a
              href={link.href}
              className="text-white/75 hover:text-white transition-colors"
            >
              {link.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
    <div className="mt-6 flex flex-wrap items-center justify-between gap-4 border-t border-white/10 pt-6">
      <nav className="flex flex-wrap items-center gap-x-5 gap-y-2 text-white/55 text-xs">
        {POLICY_LINKS.map((link) => (
          <a
            key={link.href}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white transition-colors"
          >
            {link.label}
          </a>
        ))}
      </nav>
      <span className="text-white/25 text-xs">&copy; 2026 Juice Analytics</span>
    </div>
  </footer>
);
